module.exports = __webpack_public_path__ + "media/assets/icons/sidebar_minus-b78885adbda89b890f7fa3afb7a1a442.svg";